export default {
  allMembers: {},
  singleMembers: {},
  requestlist: [],
  connectionlist: [],
};
